import * as Sentry from '@sentry/vue'

const isProd = import.meta.env.PROD && import.meta.env.VITE_APP_HEROKU_ENV === 'production'

export const maLogger = {
  log: (message, ...params) => {
    if (isProd)
      return
    // eslint-disable-next-line no-console
    console.log(message, ...params)
  },
  info: (message, ...params) => {
    if (isProd)
      return
    // eslint-disable-next-line no-console
    console.info(message, ...params)
  },
  warn: (message, ...params) => {
    if (isProd)
      return
    console.warn(message, ...params)
  },
  error: (message, ...params) => {
    if (isProd)
      Sentry.captureMessage(message, { level: 'error', extra: { ...params } })
    else console.error(message, ...params)
  },
}
